import React from 'react';
import check from "../../../assets/images/shared/modals/check.png";
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";

const ModalRegister = ({ showModalRegister, closeModal, isSalida, onClose }) => {
  if (!showModalRegister) return null;

  const handleClose = () => {
    closeModal(); // Cierra el modal
    if (onClose) {
      onClose(); // Ejecuta la función de redirección
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="md:w-[482px] md:h-[276px] w-[276px] h-[230px] bg-white rounded-3xl shadow-lg flex flex-col  ">
        <div className='flex justify-end'>
          <button
            onClick={handleClose}
            className="px-4 py-2 rounded-md"
          >
            <img src={buttonClose} alt="Cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center'>
          <img src={check} alt="registrado" className="md:w-[150px] md:h-[150px] w-[110px] h-[110px] mb-4" />
          <p className="mb-6 text-sm font-medium text-gray-700">
          {isSalida ? "¡Registro de salida exitoso!" : "¡Registro de llegada exitoso!"}
          </p>
        </div>
      </div>
    </div>
  );
};
export default ModalRegister;
